export const alertTypeFormatter = type => {
  const mapper = {
    alerts_fire: 'Fire',
    alerts_law_enforcement: 'Police',
    alerts_medical: 'EMS',
    alerts_active_assailant: 'Active Assailant',
    alerts_train_incident: 'Train Incident',
  };
  return mapper[type] || '';
};

// status constants

export const DECLINED = 'declined';
export const ACCEPTED = 'active';
export const PENDING = 'pending';
export const OUTBOUND = 'outbound';
export const INBOUND = 'inbound';
